import { useApp } from '../../context/AppContext';
import { PageShell } from '../shared/PageShell';
import { ProtocolView } from './ProtocolView';

export function ProtocolPage() {
  const { state, dispatch } = useApp();

  if (!state.protocol) {
    return (
      <PageShell>
        <div className="flex items-center justify-center min-h-screen">
          <div className="text-center">
            <h2 className="font-display text-2xl font-bold mb-2">No Protocol Yet</h2>
            <p className="text-text-muted text-sm mb-4">Complete your lab analysis first.</p>
            <button
              onClick={() => dispatch({ type: 'SET_SCREEN', payload: 'landing' })}
              className="px-4 py-2 rounded-lg bg-accent text-white text-sm hover:bg-accent-light transition-colors"
            >
              Upload Labs
            </button>
          </div>
        </div>
      </PageShell>
    );
  }

  const handleCheckout = (email: string) => {
    dispatch({ type: 'SET_CHECKOUT_EMAIL', payload: email });
    dispatch({ type: 'SET_SCREEN', payload: 'checkout_review' });
  };

  return (
    <ProtocolView
      protocol={state.protocol}
      onBack={() => dispatch({ type: 'SET_SCREEN', payload: 'chat' })}
      onCheckout={handleCheckout}
      patientAge={state.triageData?.age}
      patientSex={state.triageData?.sex}
      biomarkers={state.labReport?.biomarkers}
    />
  );
}
